import React, { useState } from 'react'
import $t from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import Card from '../../common/Card'
import Actions from '../../../actions'
import {
  isLaterAppointment,
  isQueueAppointment,
  validAppointments,
} from '../../../utils/appointmentsUtils'
import { Button } from 'antd'
import ActionButton from '../../common/ActionButton/ActionButton'
import TimeSlotMessage from '../../common/TimeSlotMessage'
import Dialog from '../../common/Dialog'
import AppointmentStatusCard from '../../common/AppointmentStatusCard'
import Page from '../../common/Page'
import config from '../../../config.json'

import './MinorHome.css'

export const MinorHome = ({ title }) => {
  const dispatch = useDispatch()

  const [isVisitGuidelinesDisplay, setIsVisitGuidelinesDisplay] =
    useState(false)

  const beforeVisitActions = [
    {
      title: $t('beforeVisitPage.uploadFiles'),
      onPress: () =>
        dispatch(Actions.createAction(Actions.UPLOAD_FILE_PRESSED)),
      icon: 'check',
      iconSize: 12,
      className: 'before-visit-action',
    },
    {
      title: $t('beforeVisitPage.connectivityCheck'),
      onPress: () =>
        dispatch(Actions.createAction(Actions.INITIATE_CONNECTIVITY_TEST)),
      icon: 'check',
      iconSize: 12,
      className: 'before-visit-action',
    },
  ]

  const getUriAccordingToSelectedAppointment = () => {
    const etaAppoinmentImg =
      config.gcpStorageUrl + '/img/Before_Desktop.svg'
    const laterAppoinmentImg =
      config.gcpStorageUrl + '/img/Child_Appointment.svg'
    const nonApppointmentImg =
      config.gcpStorageUrl + '/img/Child_Welcome.svg'
    return isAppointmentExist
      ? isAppointmentInQueue
        ? etaAppoinmentImg
        : laterAppoinmentImg
      : nonApppointmentImg
  }

  const { appointments } = useSelector(state => state.appointments)

  const isAppointmentExist = !!appointments?.length
  const isAppointmentInQueue = !!appointments?.find(appointment =>
    isQueueAppointment(appointment)
  )
  const isAppointmentLater = !!appointments?.find(appointment =>
    isLaterAppointment(appointment)
  )

  const getLaterAppointmentCard = () => {
    const futureVisitsList = validAppointments(appointments)
    return (
      <div className="minor-future-visit">
        <h1 className="minor-title">
          {$t('homeScreen.minorHome.laterAppointment.title')}
        </h1>

        {futureVisitsList?.map(appointment => (
          <AppointmentStatusCard
            key={appointment?.id}
            appointment={appointment}
          />
        ))}
      </div>
    )
  }

  const getETAAppointmentCard = () => {
    return (
      <>
        <div className="minor-title appointment-title">
          {$t('homeScreen.minorHome.etaAppointment.title')}
        </div>
        <Card className="approved-card eta-card">
          <div className="eta">
            {$t('common.eta')}:{' '}
            <TimeSlotMessage displayOnlyTime className="eta-timer" />
          </div>
          <div className="eta-sub">
            {$t('beforeVisitPage.waitingTimeMayChange')}
          </div>
          <div className="eta-sub-bold">{$t('beforeVisitPage.stayTuned')}</div>
        </Card>
        {getBeforeVisitActions()}
      </>
    )
  }

  const getBeforeVisitActions = () => {
    return (
      <div className="before-visit-actions">
        <div className="before-visit-actions-header">
          {$t('beforeVisitPage.fillDetails')}:
        </div>
        <Card className="before-visit-actions-card">
          {beforeVisitActions?.map(action => (
            <ActionButton
              label={action?.title}
              iconName={action?.icon}
              size={action?.iconSize}
              className={action?.className}
              onPress={action?.onPress}
              displayArrow={true}
            />
          ))}
          <div className="guide-text-container">
            <div className="guide-text">{$t('beforeVisitPage.reviewOur')} </div>
            <Button
              type="link"
              className="guide-text"
              onClick={() => setIsVisitGuidelinesDisplay(true)}
            >
              {$t('beforeVisitPage.visitGuidelines')}
            </Button>
          </div>
        </Card>
      </div>
    )
  }

  const getNoAppointmentPage = () => {
    return (
      <div className="minor-welcome-page">
        <h1 className="minor-title">
          {$t('homeScreen.minorHome.welcome.title')}
        </h1>
        <div className="minor-subtitle">
          {$t('homeScreen.minorHome.welcome.subtitle')}
        </div>
      </div>
    )
  }

  return (
    <Page
      title={title}
      className="minor-page-content grey"
      displayProfile
      hideAlertBanner
    >
      <img
        alt=""
        className={isAppointmentExist ? 'minor-page-img' : 'minor-page-img big'}
        src={getUriAccordingToSelectedAppointment()}
      />
      {!isAppointmentExist && getNoAppointmentPage()}
      {isAppointmentInQueue && getETAAppointmentCard()}
      {isAppointmentLater && !isAppointmentInQueue && getLaterAppointmentCard()}
      <Dialog
        title={$t('beforeVisitPage.guidelines.title')}
        isVisible={isVisitGuidelinesDisplay}
        footerActions={[
          <Button
            key="1"
            className="dialog-action"
            type="primary"
            onClick={() => setIsVisitGuidelinesDisplay(false)}
          >
            {$t('common.understand')}
          </Button>,
        ]}
        onCancel={() => setIsVisitGuidelinesDisplay(false)}
        className="before-visit-dialog"
      >
        <div className="before-visit-content column light">
          <div className="before-visit-body">
            {$t('beforeVisitPage.guidelines.body')}
          </div>
          <div className="before-visit-note extra-light">
            {$t('beforeVisitPage.guidelines.note')}
          </div>
        </div>
      </Dialog>
    </Page>
  )
}

export default MinorHome
